import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import CurrencyFilterSelect from 'ah-trades/src/components/currency/CurrencyFilterSelect.vue';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BDCurrencyFilterSelect',
  props: {
  allowedCurrencies: { type: Array as PropType<string[]>, required: false },
  placeholder: { type: String, required: false },
  value: { type: Array, required: false, default: () => [] },
},
  emits: ["update:value"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:value', value: any[]): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, CurrencyFilterSelect, MaterialIcon }
}

})